import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface Row {
  question: string;
  content: React.ReactNode;
}
const includes = ['Implementación del sistema contratado', 'Configuración de automatizaciones', 'Integraciones contempladas en el plan', 'Mantenimiento correspondiente', 'Evolución según el plan', 'Soporte correspondiente'];
const externalCosts = ['WhatsApp / Meta / API', 'Número telefónico', 'Google Calendar', 'CRM premium', 'Telefonía', 'Consumo de IA o voz'];
const rows: Row[] = [{
  question: '¿Qué incluye ORIGEN?',
  content: <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-172" data-mp="2xt6f2eiw6hc9">
        {includes.map(item => <li key={item} className="font-body text-[13.5px] text-carbon/65 flex items-start gap-2" data-id="element-173" data-mp="2sv4xxz510s3f">
            <span className="mt-[7px] w-1 h-1 rounded-full bg-verde/60 flex-shrink-0" data-id="element-174" data-mp="3lkbyt4rydtru" />
            {item}
          </li>)}
      </ul>
}, {
  question: '¿Qué costos externos existen?',
  content: <div className="flex flex-wrap gap-1.5" data-id="element-175" data-mp="3bwqb4xyn7p43">
        {externalCosts.map(cost => <span key={cost} className="font-body text-[11.5px] text-carbon/55 bg-carbon/5 rounded-full px-3 py-1" data-id="element-176" data-mp="2y5206y04r6op">
            {cost}
          </span>)}
      </div>
}, {
  question: '¿Qué pasa con integraciones extraordinarias?',
  content: <p className="font-body text-[13.5px] text-carbon/60 leading-[1.6]" data-id="element-177" data-mp="2t5h3yvcchcfo">
        Los desarrollos e integraciones que estén fuera del alcance
        contratado se cotizan por separado. Los planes operan bajo límites
        de uso y condiciones de consumo definidos según cada implementación.
      </p>
}];
function AccordionRow({
  row
}: {
  row: Row;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-carbon/10 last:border-b-0" data-id="element-178" data-mp="idxmcmmi68li">
      <button onClick={() => setIsOpen(v => !v)} aria-expanded={isOpen} className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-carbon/[0.02] transition-colors duration-150" data-id="element-179" data-mp="fz102fzspxe5">
        <span className="font-display text-[15px] font-semibold text-carbon" data-id="element-180" data-mp="6xjckck26tff">
          {row.question}
        </span>
        <ChevronDown size={16} className={`text-carbon/45 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-181" data-mp="20jbyh5zaivp" />
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0
    }} transition={{
      duration: 0.22,
      ease: 'easeOut'
    }} className="overflow-hidden" data-id="element-182" data-mp="uoyg28nkngs9">
        <div className="px-6 pb-5" data-id="element-183" data-mp="kyvomcw3maw1">{row.content}</div>
      </motion.div>
    </div>;
}
export function IncludesSection() {
  return <section className="bg-arena py-[36px] md:py-[52px]" data-id="element-184" data-mp="1iesqkjkf4t9c">
      <div className="max-w-[720px] mx-auto px-6 md:px-20" data-id="element-185" data-mp="1dmhr1htlb9hb">
        <div className="border border-carbon/10 rounded-[12px] overflow-hidden" data-id="element-186" data-mp="1dky97msacqdf">
          {rows.map(row => <AccordionRow key={row.question} row={row} data-id="element-187" data-mp="1pwqxqhf4ns9e" />)}
        </div>
      </div>
    </section>;
}